import {
    SHARED_SET_LOADING,
    SET_MODEL
  } from './actionTypes.js';
  
  const initialState = {
    loading: false,
    model_name: localStorage.getItem('model_name') || 'AE Academic Advisor',
  };  
  
  const sharedReducer = (state = initialState, action) => {
    switch (action.type) {
      case SHARED_SET_LOADING:
        return { ...state, shared_loading: action.payload };

      case SET_MODEL:
        return {...state, model_name: action.payload}
  
      default:
        return state;
    }
  };
  
  export default sharedReducer;
  